import httpRequest from 'httpRequest'
import { CreateTimeClockContract } from 'models'
import { TimeClockInfoContract } from 'models/TimeClockInfoContract'

const TIME_CLOCK_PREFIX = '/location/time-clocks'

const timeClockService = {
    getCurrentUserTimeClock: () => {
        return httpRequest.get<TimeClockInfoContract>(
            `${TIME_CLOCK_PREFIX}/info`,
        )
    },
    createCurrentUserTimeClock: (_cur: CreateTimeClockContract) => {
        return httpRequest.post<TimeClockInfoContract>(
            `${TIME_CLOCK_PREFIX}`,
            _cur,
        )
    },
    clockOutUsers: (userIds: string[]) =>
        httpRequest.post(`${TIME_CLOCK_PREFIX}/clock-out/users`, userIds),
}

export default timeClockService
